// Global simulation constants. The sim is fully decoupled from wall-clock time;
// everything is expressed in ticks and world units.

export const TICK_RATE = 30; // simulation ticks per second
export const DT = 1 / TICK_RATE; // seconds per tick

// Entity capacities (struct-of-arrays are pre-allocated to these sizes).
export const MAX_ENTITIES = 4096;
export const MAX_PROJECTILES = 8192;

// Owners. 0 is reserved for neutral (wreckage, map features).
export const OWNER_NEUTRAL = 0;
export const OWNER_PLAYER = 1;
export const OWNER_ENEMY = 2;

// Entity kinds.
export const KIND_UNIT = 0;
export const KIND_BUILDING = 1;
export const KIND_WRECKAGE = 2;
export const KIND_FEATURE = 3; // trees / rocks

// Projectile kinds.
export const PROJ_BOLT = 0; // straight, fast (lasers / bolts)
export const PROJ_ARC = 1; // ballistic arc (artillery / plasma / rockets)

// Friendly-fire multiplier for splash damage (GDD §6.1 / §12).
export const FRIENDLY_FIRE_MULT = 0.35;

// Wreckage returns this fraction of the unit's metal cost when reclaimed.
export const WRECKAGE_METAL_FRACTION = 0.6;

// Targeting rescans are amortized: each unit rescans ~4x/second, staggered.
export const RESCAN_INTERVAL_TICKS = 8;
